import styled from 'styled-components';

export const ColumnEmailsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .ant-btn {
    margin-right: 8px;
  }
`;
